import { Link, useLocation } from 'react-router-dom';
import HopplaLogo from '../ui/HopplaLogo';
import { SidebarNavItem } from '../navigation/SidebarNavItem';
import { useAuth } from '../../features/auth/auth-context';
import { canReadAudit } from '../../lib/permissions';

export function AdminSidebar(): JSX.Element {
  const location = useLocation();
  const { admin } = useAuth();
  const canOperate = admin?.role === 'OPS_ADMIN' || admin?.role === 'SUPER_ADMIN';
  const items = [
    { to: '/', label: 'Vue d’ensemble' },
    { to: '/clients', label: 'Clients' },
    { to: '/web-projects', label: 'Projets Web' },
    ...(canOperate ? [
      { to: '/showcase', label: 'Vitrine du site' },
      { to: '/showcase-home', label: 'Vitrine Accueil' },
      { to: '/inquiries', label: 'Demandes Web' },
      { to: '/contacts', label: 'Contacts' },
      { to: '/operations', label: 'Surveillance' },
    ] : []),
    ...(canReadAudit(admin?.role) ? [{ to: '/audit', label: 'Journal d’audit' }] : []),
  ];

  return (
    <aside className="admin-sidebar">
      <Link to="/" className="admin-sidebar-brand" aria-label="Accueil Bulle Hoppla">
        <img src="/icons/hoppla-favicon-192.png" alt="" className="admin-brand-mark" />
        <span className="admin-brand-copy">
          <HopplaLogo className="admin-brand-logo" />
          <span className="admin-brand-subtitle">Bulle · administration</span>
        </span>
      </Link>

      <p className="admin-sidebar-section-label">Espace de travail</p>
      <nav className="admin-sidebar-nav" aria-label="Navigation principale">
        {items.map((item) => (
          <SidebarNavItem
            key={item.to}
            to={item.to}
            label={item.label}
            isActive={item.to === '/'
              ? location.pathname === '/'
              : location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)}
          />
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        <span className="admin-sidebar-footer__dot" aria-hidden="true" />
        <span>Portail de relecture Web</span>
      </div>
    </aside>
  );
}

export default AdminSidebar;
